import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** トリガー */
enum Trigger {
  /** 手動 */
  manual = 'MANUAL',
}

const nameConfig = {
  manual: new Map([
    [Locale.ja, '手動'],
    [Locale.en, 'manual'],
  ]),
};

const toEnum = rawValueToEnum(Trigger, Trigger.manual);
const toDisplay = enumToName(Trigger, nameConfig);

export const trigger = {
  enum: Trigger,
  nameConfig,
  toEnum,
  toDisplay,
};
export type { Trigger };
